import {Routes} from "@angular/router";
import {CreateRemedialComponent} from "./create-remedial.component";

export const createRemedialRoutes: Routes = [
  {path: '', component: CreateRemedialComponent},
  {path: ':id', component: CreateRemedialComponent}
];
